import React from "react";
import { useLocation } from "react-router-dom";
import NJTraceDetailInfo from "../../components/Detail/_NJTraceDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


function NJTraceDetail() {
    let query = useQuery();

    return (
        <div>
            <NJTraceDetailInfo ID={query.get("ID")} department={query.get("Dept")} />
        </div>
    );
}

export default NJTraceDetail;